import * as React from 'react';
import Dialog from '@material-ui/core/Dialog';
import * as Modal from '../../../common/modalDialog';
import Button from '@material-ui/core/Button'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCheck, faTimes } from '@fortawesome/free-solid-svg-icons';
import DiseaseService from '../../../services/diseaseService';
import { DiseaseGridModel, DiseaseForGridModel, DiseaseFilterSettingsModel } from "../../../models";
import Translate from '../../../common/functions/translate';
import Paginator from '../../../common/components/paginator/paginator';
import Radio from '@material-ui/core/Radio';
import UserDiseaseFilter from '../userDiseases/diseaseFilter';
import Spinner from '../../../common/components/spinner/spinner';
import Growl from '../../../common/components/alertMessage/growl';

interface IProps {
  selectedDisease: DiseaseForGridModel,
  isVisible: boolean,
  cancelClick: any,
  addClick: any,
  lang: string,
}

interface IState {
  isLoading: boolean;
  from: number;
  numberOfRows: number;
  totalRecordsCount: number;
  allDiseases: Array<DiseaseForGridModel>;
  currentDisease: DiseaseForGridModel;
  currentFilterSettings: DiseaseFilterSettingsModel;
  page: number;
  numberOfPages: number;
}

const initFrom = 0;
const numberOfRows = 20;

class DiseasesListDialog extends React.Component<IProps, IState> {
  diseaseService = new DiseaseService(this.props.lang);
  growl: any;

  constructor(props: IProps) {
    super(props);

    this.state = {
      isLoading: false,
      from: initFrom,
      numberOfRows: numberOfRows,
      totalRecordsCount: 0,
      allDiseases: new Array<DiseaseForGridModel>(0),
      currentDisease: this.props.selectedDisease,
      currentFilterSettings: new DiseaseFilterSettingsModel(),
      page: 1,
      numberOfPages: 1
    }
  }

  componentDidMount() {
    //this.getAllFilteredItems(this.state.page, this.state.numberOfRows, this.state.currentFilterSettings);
  }

  getAllFilteredItems(page: number, numberOfRows: number, currentFilterSettings: DiseaseFilterSettingsModel) {
    let from = (page - 1) * this.state.numberOfRows;
    this.setState({
      isLoading: true
    });

    this.diseaseService.getAllDiseases(from, numberOfRows, currentFilterSettings, this.props.lang).then(
      (data: DiseaseGridModel) => {
        this.setState({
          isLoading: false,
          from: from,
          allDiseases: data.diseases,
          totalRecordsCount: data.totalRecordsCount,
          numberOfPages: (data.totalRecordsCount % this.state.numberOfRows > 0 ?
            data.totalRecordsCount / this.state.numberOfRows + 1 : data.totalRecordsCount / this.state.numberOfRows)
        });
      })
      .catch(error => {
        this.growl.show({ severity: 'error', summary: error.message });
        this.setState({
          isLoading: false
        });
      });
  }

  paginataorClick = (page) => {
    this.setState({ page: page }, () => this.getAllFilteredItems(page, this.state.numberOfRows, this.state.currentFilterSettings));
  }

  handleCurrentDiseaseSelection = (e) => {
    this.setState({
      currentDisease: e.data
    });
  }

  displayHeaderSelection(currentDisease: DiseaseForGridModel) {
    if (!currentDisease || (currentDisease && !currentDisease.diseaseCode)) {
      return <div style={{ textAlign: 'left' }}>{Translate("No Selection")}</div>;
    }
    else {
      return <div style={{ textAlign: 'left' }}>{Translate("Disease")}:&nbsp;
            {[currentDisease.diseaseCode, currentDisease.diseaseName].filter(Boolean).join(' ')}
      </div>
    }
  }

  handleCancelButton = () => {
    this.props.cancelClick();
  }

  handleAddButton = event => {
    event.preventDefault();
    const currentDisease = this.state.currentDisease;
    this.props.addClick(currentDisease);
  }

  onSelectDisease = (disease: DiseaseForGridModel) => {
    this.setState({ currentDisease: { ...disease } });
  }

  handleSearchButtonClick = (settings) => {
    this.setState({
      isLoading: true, page: 1, currentFilterSettings: settings
    }, () => this.getAllFilteredItems(this.state.page, this.state.numberOfRows, settings));
  }

  handleOnClearClick = () => {
    this.setState({ currentFilterSettings: new DiseaseFilterSettingsModel(), page: 1, numberOfPages: 0, allDiseases: [], totalRecordsCount: 0 });
  }

  render() {
    let { allDiseases, currentDisease, numberOfPages, page, isLoading, currentFilterSettings } = this.state;

    return (
      <Dialog
        open={this.props.isVisible}
        onClose={this.handleCancelButton}
        fullWidth
      >
        <Modal.DialogTitle id="customized-dialog-title" onClose={this.handleCancelButton}>{Translate('Diseases')}</Modal.DialogTitle>
        <Modal.DialogContent>
          {isLoading ? <Spinner /> : null}
          <Growl ref={(el) => this.growl = el} />
          <div className="medicine-filter-panel">
            <UserDiseaseFilter
              onClearClick={this.handleOnClearClick}
              onSearchClick={this.handleSearchButtonClick}
              totalRecordsCount={this.state.totalRecordsCount}
              lang={this.props.lang} />
          </div>
          <div>
            <ul className="list-items">
              {allDiseases && allDiseases.length > 0 ? allDiseases.map((m: DiseaseForGridModel) =>
                <li key={m.diseaseId + 'uListDisId'} onClick={() => this.onSelectDisease(m)}>
                  <div className="item-actions">
                    <Radio
                      checked={currentDisease.diseaseId == m.diseaseId}
                      onChange={e => this.onSelectDisease(m)}
                      color="primary"
                    />
                  </div>
                  <div className="item-info">
                    <div className="item-name">
                      {m.diseaseCode} {m.diseaseName}
                    </div>
                  </div>
                </li>
              ) : null}
              {(!allDiseases || allDiseases.length == 0) && (!currentFilterSettings || !currentFilterSettings.alphaIndex || !currentFilterSettings.diseaseName) ?
                <span style={{ color: 'rgba(0, 0, 0, 0.54)' }}><i>{Translate("Enter name or select alpha index")}</i></span>
                : null}
            </ul>
            {numberOfPages > 1 ?
              <div style={{ marginBottom: '10px', marginTop: '10px', textAlign: "center" }}>
                <Paginator numberOfPages={numberOfPages} page={page} paginataorClick={this.paginataorClick} />
              </div>
              : null}

          </div>
        </Modal.DialogContent>
        <Modal.DialogActions>
          <div style={{ height: 50 }}>
            <Button variant="contained" size="small" onClick={this.handleCancelButton} style={{ marginRight: '10px' }}>
              <FontAwesomeIcon icon={faTimes} style={{ marginRight: '5px' }} />
              {Translate('Cancel')}
            </Button>
            <Button variant="contained" size="small" color="primary" onClick={this.handleAddButton}>
              <FontAwesomeIcon icon={faCheck} style={{ marginRight: '5px' }} />
              {Translate('Add')}
            </Button>
          </div>
        </Modal.DialogActions>
      </Dialog>
    )
  }
}

export default DiseasesListDialog;